import { RequestTicket } from 'src/types'

export default function getInitialValues(ticket: RequestTicket) {
  if (!ticket) {
    return {}
  }
  const { request_ticket_receipts, request_ticket_user_data } = ticket
  return {
    ...ticket,
    request_ticket_receipts: request_ticket_receipts.map(receipt => ({
      ...receipt,
      currency_id: receipt.currency_id?.toString() ?? '',
      payment_resource_id: receipt.payment_resource_id?.toString() ?? '',
      reference_id: receipt.reference_id?.toString() ?? '',
      service_id: receipt.service_id?.toString() ?? ''
    })),
    request_ticket_user_data: request_ticket_user_data.map(userData => ({
      ...userData,
      traveler: {
        ...userData.traveler,
        user_id: userData.traveler.user_id.toString()
      }
    }))
  }
}
